import { render, staticRenderFns } from "./table-kubo.vue?vue&type=template&id=29884c88&scoped=true&"
import script from "./table-kubo.vue?vue&type=script&lang=js&"
export * from "./table-kubo.vue?vue&type=script&lang=js&"
import style0 from "./table-kubo.vue?vue&type=style&index=0&id=29884c88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29884c88",
  null
  
)

export default component.exports